import { Power2, TimelineLite } from 'gsap';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import OnVisible from 'react-on-visible';
import { colors, fontSize, Grid, MixBlend, MixBlendDifference, MixBlendText } from 'style';
import { Media } from '..';
import CustomRangeInput from '../common/rangeInput/rangeInput.component';

class ComparisonComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.scrollpos = 0;
    this.clipXpos = 50;
    this.top = 0;
    this.bottom = 0;
    this.scrollDistance = 0;
    this.hasBeenDragged = false;
    this.moveRange = this.moveRange.bind(this);
    this.visibilityChange = this.visibilityChange.bind(this);
    this.handleResize = this.handleResize.bind(this);

    //this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      rangevalue: 0,
      width: 0,
      height: 0,
    };
  }
  moveRange(value) {
    this.hasBeenDragged = true;
    this.setState({ rangevalue: value }, this.setClip);
  }
  setClip() {
    if (this.line) {
      let width = this.state.width;
      if (window.innerWidth < width) {
        width = window.innerWidth;
      }
      this.line.style.left = `${Number(this.state.rangevalue)}%`;
      this.afterImage.style.clip = `rect(0px,${width /
        (100 / this.state.rangevalue)}px, auto, 0px)`;
    }
  }
  componentDidMount() {
    this.handleResize();

    this.addEventListeners();
  }
  visibilityChange(visible) {
    this.isVisible = visible;
    if (visible == true) {
      this.animateHandle();
    } else {
      this.moveRange(0);
    }
  }
  animateHandle() {
    var obj = { score: 0 };
    var tl = new TimelineLite();
    tl.from(obj, 0, {
      score: 0,
    });
    tl.to(obj, 1, {
      score: '+=100',
      onUpdate: () => {
        this.moveRange(Math.round(obj.score));
      },
      ease: Power2.easeInOut,
    });
    tl.to(obj, 0.5, {
      score: '-=50',
      onUpdate: () => {
        this.moveRange(Math.round(obj.score));
      },
      ease: Power2.easeInOut,
    });
  }

  /*handleScroll() {
      var visibleTop = window.scrollY - (this.top - window.innerHeight);
      var visibility = Math.round(100 * (visibleTop / this.scrollDistance));
      if (visibility > 100) {
          visibility = 100;
      }
      if (visibleTop && this.isVisible) {
          if (!this.hasBeenDragged) {
              this.scrollpos = window.scrollY;
              this.setState({ rangevalue: visibility }, this.setClip);
          }
      } else {
          this.hasBeenDragged = false;
      }
  }*/
  handleResize() {
    if (this.afterImage) {
      var bound = this.afterImage.getBoundingClientRect();
      this.top = Math.round(bound.top);
      this.bottom = Math.round(bound.top);
      this.setState({ width: Math.round(bound.width) });
      this.scrollDistance = window.innerHeight;
      this.setClip();
    }
  }
  addEventListeners() {
    //window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  }

  removeEventListeners() {
    //window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
  render() {
    const { beforeImage, afterImage, backgroundColor, beforeText, afterText } = this.props;

    let width, height;
    if (beforeImage && afterImage) {
      width = beforeImage.width || afterImage.width;
      height = beforeImage.height || afterImage.height;
    }
    if (width == null) width = 300;
    if (height == null) height = 300;

    this.setState({ width: width, height: height }, this.handleResize);

    let rangeStyle = {
      cursor: {
        size: 30,
        backgroundColor: 'transparent',
        borderWidth: 2,
        borderColor: '#fff',
      },
      track: {
        height: '100%',
        borderRadius: '0',
        borderWidth: 0,
        color: 'transparent',
        borderColor: 'transparent',
      },
    };
    return (
      <Grid.Overflow>
        <OnVisible percent={90} onChange={this.visibilityChange}>
          <ComparisonWrapper
            backgroundColor={backgroundColor && backgroundColor.hex}
            id="ComparisonComponent">
            <Grid.InnerContainer>
              <Comparison
                width={width}
                height={height}
                id="Comparison"
                                /*removed innerRef*/ ref={(el) => this.comparison = el}>
                <Line
                                    /*removed innerRef*/ ref={el => (this.line = el)}
                  cursorSize={rangeStyle.cursor.size}
                  cursorBorderWidth={
                    rangeStyle.cursor.borderWidth
                  }
                />
                <Before
                  imagewidth={width}
                  imageheight={height}
                  backgroundColor={
                    backgroundColor && backgroundColor.hex
                  }>
                  <Text right={0}>{beforeText}</Text>
                  <Media image={beforeImage} />
                </Before>
                <After /*removed innerRef*/ ref={el => (this.afterImage = el)}>
                  <AfterWrapper
                    imagewidth={width}
                    imageheight={height}
                    backgroundColor={
                      backgroundColor &&
                      backgroundColor.hex
                    }>
                    <Text left={0}>{afterText}</Text>
                    <Media image={afterImage} />
                  </AfterWrapper>
                </After>
                <CustomRangeInput
                  type="range"
                  min={0}
                  max={100}
                  id="slider"
                  onChange={this.moveRange}
                  value={this.state.rangevalue}
                  ref={el => (this.slider = el)}
                  styling={rangeStyle}
                  css={range_css}
                />
              </Comparison>
            </Grid.InnerContainer>
          </ComparisonWrapper>
        </OnVisible>
      </Grid.Overflow>
    );
  }
}

const range_css = css`
    position: absolute;
    left: -14px;
    top: 0;
    width: calc(100% + 30px);
    ${MixBlendDifference};
    ${MixBlend(
  css`
            border-color: ${colors.fallbackColor};
        `,
  css`
            border-color: #fff;
        `
)};
`;

const ComparisonWrapper = styled.div`
    background-color: ${props => props.backgroundColor};
`;

const Comparison = styled.div`
    width: ${props => props.width}px;
    max-width: 100%;
    max-height: 100vh;

    position: relative;
    margin: 0 auto;

    &::before {
        content: '';
        width: 1px;
        margin-left: -1px;
        float: left;
        height: 0;
        padding-top: ${props =>
    props.width && props.height
      ? 100 * (props.height / props.width)
      : 100}%;
    }
    &::after {
        content: '';
        display: table;
        clear: both;
    }
`;
const Line = styled.div`
    position: absolute;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 0;
    ${MixBlendDifference};
    &:before,
    &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0px;
        height: ${props => `calc(50% - ${props.cursorSize / 2}px)`};
        border-right: 2px solid #fff;
    ${MixBlendDifference};
    ${MixBlend(
  css`
                border-color: ${colors.fallbackColor};
            `,
  css`
                border-color: #fff;
            `
)};
    }
    &:after {
        top: auto;
        bottom: 0;
    }
`;
const Before = styled.div`
    position: relative;
    font-size: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    isolation: isolate;
    background-color: ${props => props.backgroundColor};

    ${Media} svg {
        max-width: initial !important;
        height: 100% !important;
    }
    .gatsby-image-outer-wrapper {
        width: ${props => props.imagewidth}px;
        max-width: 100%;
        max-height: 100vh;
        .gatsby-image-wrapper{
          max-height: 100vh;
          img{
            object-fit: contain !important;
          }
        }
    }
`;
const After = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    font-size: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    isolation: isolate;
`;
const AfterWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: ${props => props.backgroundColor};
    position: relative;

    ${Media} svg {
        max-width: initial !important;
        height: 100% !important;
    }
    .gatsby-image-outer-wrapper {
        width: ${props => props.imagewidth}px;
        max-width: 100%;
        max-height: 100vh;
        .gatsby-image-wrapper{
          max-height: 100vh;
          img{
            object-fit: contain !important;
          }
        }
    }
`;
const Text = styled.div`
    ${MixBlendDifference};
    ${MixBlendText({
  fallbackshadowcolor: '#fff',
})};

    position: absolute;
    z-index: 1;
    padding: 10px;
    left: ${props => props.left};
    right: ${props => props.right};
    font-size: ${fontSize(16)};
`;

export default ComparisonComponent;
